export const InputTypes = {
    TEXT: 'text',
    PASSWORD: 'password',
    EMAIL: 'email',
    NUMBER: 'number',
    SEARCH: 'search',
    TEL: 'tel',
    URL: 'url',
};

export const INPUT_TYPES = [
    InputTypes.TEXT,
    InputTypes.PASSWORD,
    InputTypes.EMAIL,
    InputTypes.NUMBER,
    InputTypes.SEARCH,
    InputTypes.TEL,
    InputTypes.URL,
];
